import { useState, useRef, useCallback } from 'react';
import { OverlayScrollbars } from 'overlayscrollbars';

export const useScrollHandling = () => {
  const [shouldAutoScroll, setShouldAutoScroll] = useState(true);
  const [scrollDirection, setScrollDirection] = useState<'up' | 'down' | null>(null);
  const lastScrollTop = useRef(0);

  const handleScroll = useCallback((_: OverlayScrollbars, event: Event) => {
    const container = event.target as HTMLElement;
    const maxScrollHeight = container?.scrollHeight - container?.clientHeight;
    const scrollThreshold = maxScrollHeight - 300;
    const currentScrollTop = container?.scrollTop;

    setShouldAutoScroll(currentScrollTop >= scrollThreshold && currentScrollTop <= maxScrollHeight);
    setScrollDirection(currentScrollTop > lastScrollTop.current ? 'down' : 'up');
    lastScrollTop.current = currentScrollTop;
  }, []);

  return { shouldAutoScroll, scrollDirection, handleScroll };
};
